import { FC, PropsWithChildren } from 'react'
import { Typography } from '@mui/material'

const EmptyListAlert:FC<PropsWithChildren<{alert:string,isData:boolean}>> = ({children,alert,isData})=>{
  return (
    <div className="grid grid-cols-2 items-center">
      <div className="flex justify-end gap-3" >
        {!isData && <Typography variant='h6' >{alert}</Typography>}
      </div>
      <div>
        {children}
      </div>
    </div>
  )
}

export default EmptyListAlert
